import * as React from "react";
import { TextInput, Button, Grid, Title, Card, Text, useMantineTheme } from "@mantine/core";
import { Link, useSearchParams } from "react-router-dom";

import { AdapterType } from "@supportinitiative/common";

import { escapeRegExp } from "../utilities";
import { useAdapters } from "../hooks";
import Loading from "../ui/Loading";
import { styles } from "../styles";

function getIsMatch(filter: string) {
  const isMatch = (adapter: AdapterType) => {
    const re = new RegExp(escapeRegExp(filter), "i");
    return re.test(adapter.name) || re.test(adapter.displayName) || re.test(adapter.description);
  };
  return isMatch;
}

export default function Adapters(props: { type?: string }) {
  let [searchParams] = useSearchParams();
  let entityId = searchParams.get("entityId");

  let [filter, setFilter] = React.useState("");
  const { data: adapters, isLoading } = useAdapters(entityId, props.type);
  let [filteredAdapters, setFilteredAdapters] = React.useState<AdapterType[]>([]);
  const theme = useMantineTheme();

  React.useEffect(() => {
    if (adapters) {
      let filteredValues = adapters.filter(getIsMatch(filter));
      setFilteredAdapters(filteredValues);
    }
  }, [adapters, filter]);

  return (
    <div style={{ marginTop: theme.spacing.lg }}>
      <Title order={3}>
        {props.type
          ? props.type === "POLICY"
            ? "Policies"
            : props.type === "LOADER"
              ? "Loaders"
              : "Adapters"
          : "Adapters"}
      </Title>
      <Grid align="center" gutter={"xs"} mb="xs">
        <Grid.Col span={3}>
          <TextInput
            placeholder="Search"
            onChange={(event) => {
              setFilter(event.target.value);
              let filteredValues = adapters.filter(getIsMatch(event.target.value));
              setFilteredAdapters(filteredValues);
            }}
          />
        </Grid.Col>
        <Grid.Col span={1}>
          <Button
            color="teal"
            styles={() => ({
              root: {
                // margin: "5px",
              },
            })}
            aria-label="New"
            fullWidth
            component={Link}
            to={`/app/${
              props.type
                ? props.type === "POLICY"
                  ? "policies"
                  : props.type === "LOADER"
                    ? "loaders"
                    : "adapters"
                : "adapters"
            }/new?entityId=${entityId}`}
          >
            New
          </Button>
        </Grid.Col>
      </Grid>

      {isLoading ? (
        <Grid align="center" gutter={"xs"} mb="xs" mt="lg">
          <Grid.Col span={3}>
            <Loading />
          </Grid.Col>
        </Grid>
      ) : (
        <>
          {filteredAdapters.length > 0 ? (
            <Grid align="flex-start" gutter={"xs"} mb="xs">
              {filteredAdapters.map((adapter) => {
                return (
                  <Grid.Col span={3} key={adapter.id as unknown as string}>
                    <Card
                      component={Link}
                      to={`/app/${
                        props.type
                          ? props.type === "POLICY"
                            ? "policies"
                            : props.type === "LOADER"
                              ? "loaders"
                              : "adapters"
                          : "adapters"
                      }/edit?id=${adapter.id}&entityId=${entityId}`}
                      shadow="sm"
                      p="xs"
                      data-testid="adapter"
                    >
                      <Text fw={500}>{adapter.name}</Text>
                      <Text
                        size="sm"
                        style={{
                          color: theme.colors.gray[7],
                          lineHeight: 1.5,
                        }}
                      >
                        {adapter.description}
                      </Text>
                    </Card>
                  </Grid.Col>
                );
              })}
            </Grid>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: theme.spacing.lg,
              }}
            >
              <Text fw={500} style={styles.nodata} data-testid="nodata">
                No Adapters
              </Text>
            </div>
          )}
        </>
      )}
    </div>
  );
}
